import { Component, Input, OnInit, Output } from '@angular/core';
import { Advisor, CompanyInfo } from '../customer-admin.model';
import { SelectItem } from 'primeng/api';
import { Store } from '@ngrx/store';
import * as fromCompanyInfoActions from '../store/company-info/company-info.actions';
import * as fromCompanyInfoReducer from '../store/company-info/company-info.reducer';
import { ReplaySubject } from 'rxjs';
import { IUserInfo } from '../../user-info';
import moment from 'moment';
import { IState } from '../../lookups';

@Component({
    selector: 'ef-customer-admin-presenter',
    templateUrl: './customer-admin-presenter.component.html',
    styleUrls: ['./customer-admin-presenter.component.scss'],
    standalone: false
})
export class CustomerAdminPresenterComponent implements OnInit {
    private ItemsSubject = new ReplaySubject<Array<CompanyInfo>>(1);
    private _items: Array<CompanyInfo>;
    @Input() set items(value: Array<CompanyInfo>) {
        if (value && value.length > 0) {
            this._items = value;
            this.ItemsSubject.next(value);
            if (value[0] != null) {
                this.customerID = value[0].CustomerID;
                this.customerPIN = value[0].PIN;
                this.productCode = value[0].ProductCode;
                this.adminCount = value[0].AdminCount;
                this.companyName = value[0].Name;
                this.primaryemail = value[0].primaryemail;
                this.address = value[0].Address1;
                this.address2 = value[0].Address2;
                this.address3 = value[0].Address3;
                this.city = value[0].City;
                this.selectedState = value[0].State;
                this.zip = value[0].ZipCode;
                this.installLink = value[0].efdinstallurl;
                this.crystalReportsLink = value[0].CRinstallurl;
                this.microsoftDriverLink = value[0].MSOLEDBinstallurl;
                this.selectedAdvisor = value[0].AdvisorID;
                this.modifiedBy = value[0].eFCModifiedBy;

                this.modified = (value[0].eFCModifiedBy != null && value[0].eFCModifiedDate != null) ? `Last modified on ${moment(value[0].eFCModifiedDate).format('MM/DD/YYYY HH:mm:ss')} by ${value[0].eFCModifiedBy}` : 'No previous updates found.';
            }

        }
    }
    get items(): Array<CompanyInfo> {
        return this._items;
    }

    private AdvisorSubject = new ReplaySubject<Array<Advisor>>(1);
    private _advisors: Array<Advisor>;
    @Input() set advisors(value: Array<Advisor>) {
        if (value && value.length > 0) {
            this._advisors = value;
            this.AdvisorSubject.next(value);
            this.advisorsSelectItem = value.map(x => ({
                label: x.AdvisorName,
                value: x.AdvisorID
            }));
        }
    }
    get advisors(): Array<Advisor> {
        return this._advisors;
    }

    private StatesSubject = new ReplaySubject<Array<IState>>(1);
    private _states: Array<IState>;
    @Input() set states(value: Array<IState>) {
        if (value && value.length > 0) {
            this._states = value;
            this.StatesSubject.next(value);
            this.statesSelectItem = value.map(x => ({
                label: x.State,
                value: x.State
            }));
        }
    }
    get states(): Array<IState> {
        return this._states;
    }

    private UserInfoSubject = new ReplaySubject<IUserInfo>(1);
    private _userinfo: IUserInfo;
    @Input() set userInfo(value: IUserInfo) {
        if (value) {
            this._userinfo = value;
            this.UserInfoSubject.next(value);
            this.employeeName = value.EmployeeName;
        }
    }
    get userInfo(): IUserInfo {
        return this._userinfo;
    }

    statesSelectItem: SelectItem[];
    advisorsSelectItem: SelectItem[];
    selectedAdvisor: any;
    selectedState: any;
    customerID: any;
    customerPIN: any;
    productCode: any;
    adminCount: any;
    companyName: any;
    primaryemail: any;
    address: any;
    address2: any;
    address3: any;
    city: any;
    //state: any;
    zip: any;
    installLink: any;
    crystalReportsLink: any;
    microsoftDriverLink: any;
    modifiedBy: any;
    advisorMessage = `An authorized eFAACT Advisor is allowed access to your eFAACT data.
     In order to open your data, the eFAACT Advisor must also be setup as a QuickBooks Vendor and assigned a valid eFAACT userID and password.`;
    acknowledgedMessage = `I acknowledge the statement of understanding.`;
    acknowledged = false;
    employeeName: any;
    modified: any;

    // @Input() version: string;
    // public environment = environment;
    // eFAACTVersion = `${environment.version}-${environment.environment}`;

    @Output() UpdateCompanyInfo = new ReplaySubject<any>(1);
    @Output() UpdateAdvisor = new ReplaySubject<any>(1);

    ngOnInit(): void {}

    updateCompanyInfo() {
        if (this.items != null) {
            const data = JSON.stringify({
                ...this.items[0],
                CustomerID: this.customerID,
                Name: this.companyName,
                primaryemail: this.primaryemail,
                PIN: this.customerPIN,
                Address1: this.address,
                Address2: this.address2,
                Address3: this.address3,
                City: this.city,
                State: this.selectedState,
                ZipCode: this.zip,
                AdvisorName: '',
                AdvisorID: this.selectedAdvisor,
                eFCModifiedBy: this.employeeName,
                IsAdminUpdate: false
            });

            this.UpdateCompanyInfo.next(data);
        } else {
            alert('Update failed');
        }

    }
    updateAdvisor() {
        if (this.items != null) {
            const data = JSON.stringify({
                ...this.items[0],
                CustomerID: this.customerID,
                Name: this.companyName,
                primaryemail: this.primaryemail,
                PIN: this.customerPIN,
                Address1: this.address,
                Address2: this.address2,
                Address3: this.address3,
                City: this.city,
                State: this.selectedState,
                ZipCode: this.zip,
                AdvisorName: '',
                AdvisorID: this.selectedAdvisor,
                eFCModifiedBy: this.employeeName,
                IsAdminUpdate: false
            });

            this.UpdateAdvisor.next(data);
        } else {
            alert('Update failed.')
        }

    }
}
